<template>
    <div>
        <breadCrumb 
            :icon="'fa-calendar-edit'"
            :category="$t(`sideNav.navSalonSetting`)"
            :subCategory="$t(`subMenu.salon_setting_booking`)"
            :subSubCategory="''">
        </breadCrumb>
        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 pb-4">
                    <div class="row w-100">
                        <div class="col-sm-12 col-md-4"> 
                            <div class="form-group d-flex">
                                <div class="input-group-prepend w-100">
                                    <label class="input-group-text border-top-right-radius-0 border-bottom-right-radius-0 border-right-0">
                                        <i class="fas fa-store"></i>
                                    </label>
                                    <multiselect  v-model="selectedOutlet" label="text" track-by="id" :options="outlet" :searchable="false" :show-labels="false" openDirection="below" @select="filterByOutlet">
                                        <template slot="option" slot-scope="{ option }">{{option.text}}</template>
                                    </multiselect>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <form @submit.prevent="submitBooking">
                            <div class="mt-3 mb-3">
                                <h4>{{$t('header.booking_hour')}}</h4>
                            </div>
                            <div class="row pb-5">
                                <div class="col-lg-6 col-xl-6">
                                    <div class="form-group">
                                        <label class="form-label">{{$t('label.start_time')}}</label>
                                        <div class="input-group bg-white shadow-inset-2">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text bg-transparent border-right-0">
                                                    <i class="fas fa-clock"></i>
                                                </span>
                                            </div>
                                            <vue-timepicker class="form-control bg-transparent" format="H:00" hour-label="Hour" auto-scroll close-on-complete v-model="startTime"></vue-timepicker>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-xl-6">
                                    <div class="form-group">
                                        <label class="form-label">{{$t('label.end_time')}}</label>
                                        <div class="input-group bg-white shadow-inset-2">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text bg-transparent border-right-0">
                                                    <i class="fas fa-clock"></i>
                                                </span>
                                            </div>
                                            <vue-timepicker class="form-control bg-transparent" format="H:00" hour-label="Hour" auto-scroll close-on-complete v-model="endTime"></vue-timepicker>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="form-group">
                                <b-button size="xs" variant="primary" @click="getMessage(selectedOutlet)" v-b-modal.reminderMessageModal>Reminder Message</b-button>
                            </div> -->
                            <!-- <div class="form-group">
                                <label class="form-label">Mobile</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-phone"></i>
                                        </span>
                                    </div>
                                    <input type="phone" disabled read-only class="form-control bg-transparent pl-3" placeholder="Mobile" v-model="mobile">
                                </div>
                            </div> -->
                            <div class="form-group">
                                <label class="form-label">Whatsapp</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fab fa-whatsapp"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control bg-transparent pl-3" placeholder="Whatsapp" v-model="whatsapp">
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">{{$t('label.confirmation_msg')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-comment-alt-lines"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.confirmation_msg')" v-model="confirmation">
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="form-label">{{$t('label.reminder_msg')}}</label>
                                <div class="input-group bg-white shadow-inset-2">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-transparent border-right-0">
                                            <i class="fas fa-comment-alt-exclamation"></i>
                                        </span>
                                    </div>
                                    <input type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.reminder_msg')" v-model="reminder">
                                </div>
                            </div>
                            <div class="text-left mb-3">
                                <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <b-modal title="Whatsapp Reminder" id="reminderMessageModal">
            <div class="d-flex flex-column">
                <label>Message</label>
                <b-form-input v-model="whatsappReminder.message" type="text"></b-form-input>
            </div>
            <div class="d-flex flex-column">
                <label>Mobile</label>
                <b-form-input v-model="whatsappReminder.mobile" type="text"></b-form-input>
            </div>
            <div class="d-flex flex-column">
                <label>Whatsapp</label>
                <b-form-input v-model="whatsappReminder.whatsapp" type="text"></b-form-input>
            </div>
                  <template #modal-footer="{ close }">
        <div class="d-flex w-100 justify-content-center">
          <b-button @click="close()" class="mr-1">Cancel</b-button>
          <b-button variant="primary" @click="saveReminder()">Save</b-button>
        </div>
      </template>
        </b-modal>
    </div>
</template>

<script>
import BreadCrumb from './../../Bread_Crumb'
import axios from 'axios'
import VueTimepicker from 'vue2-timepicker'
import {handleSessionExpired, toastrExe} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'booking',
    components: { VueTimepicker, BreadCrumb },
    data(){
        return{
            outlet: [], 
            selectedOutlet: 0,
            startTime: "", 
            endTime: "",
            mobile: "",
            whatsapp: "",
            confirmation: "", 
            reminder: "",
            whatsappReminder:{
                outletID:0,
                mobile:"",
                message:"",
                whatsapp:""
            }
        }
    },
    methods:{
        closeModal(isError){
            if(!isError){
                this.getBooking(this.selectedOutlet);
            }
            this.$parent.isModalShow = false;
        },filterByOutlet(item){
            this.selectedOutlet = item;
            this.getBooking(this.selectedOutlet);
        },
        submitBooking(){
            var sTime = parseInt(this.startTime.split(":")[0]);
            var eTime = parseInt(this.endTime.split(":")[0] - 1);

            var hours = [];
            while(sTime<=eTime){
                hours.push(sTime);
                sTime++;
            }
            var data = {
                batch: hours,
                // msg: {
                //     confirmation: this.confirmation,
                //     reminder: this.reminder
                // }
            }
            
            let $vm = this
            let QUERY_STRING = "/" + this.selectedOutlet.id + this.$api.BOOKING
            let url = this.$api.OUTLET + QUERY_STRING

            this.$axios({
                method: 'post', 
                url: `https://bebusiness.tunai.io/outlet/${this.selectedOutlet.id}/bookhour/batch`,
                // url: `https://bebusiness.tunai.io/outlet/${this.selectedOutlet.id}/bookhour/enforceApptHour`,
                // url: url,
                // baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data,
            })
            .then((response) => {
                // if(response.status == 200){
                //     var message = $vm.$i18n.t('subMenu.salon_setting_booking') + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.update')})
                //     $vm.$parent.setModal($vm, false, true, message);
                // }
                this.submitMessage()
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    this.setModal(true, true, $vm.$i18n).t('message.error.systen_error');
                }
            })
        },
        submitMessage(){
            var data = {
                // mobile: this.mobile,
                whatsapp: this.whatsapp,
                confirmation: this.confirmation,
                reminder: this.reminder
            }
            
            let $vm = this
            let QUERY_STRING = "/" + this.selectedOutlet.id + this.$api.BOOKING
            let url = this.$api.OUTLET + QUERY_STRING

            this.$axios({
                method: 'post', 
                // url: `https://bebusiness.tunai.io/outlet/${this.selectedOutlet.id}/bookhour/enforceApptHour`,
                url: `https://bebusiness.tunai.io/outlets/${this.selectedOutlet.id} /book/message`,
                // url: url,
                // baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
                data: data,
            })
            .then((response) => {
                if(response.status == 200){
                    var message = $vm.$i18n.t('subMenu.salon_setting_booking') + $vm.$i18n.t('message.success.success', {'action': $vm.$i18n.t('message.success.action.update')})
                    $vm.$parent.setModal($vm, false, true, message);
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }else{
                    this.setModal(true, true, $vm.$i18n).t('message.error.systen_error');
                }
            })
        },
        getBooking(outlet){
            let $vm = this
            const url = $vm.$api.OUTLET + "/" + outlet.id + $vm.$api.BOOKING

            $vm.$axios({
                method: 'get', 
                url: `https://bebusiness.tunai.io/outlet/${outlet.id}/bookhour`,
                // url: `https://bebusiness.tunai.io/outlet/${outlet.id}/bookhour/enforceApptHour`,
                // baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')}
            })
            .then((response) => {
                var results = response.data;
                
                let start = 23
                let end = 0
                if(results && results['hours']) {
                    for(let hour of results['hours']) {
                        if(hour['appt']) {
                            if(hour['hourID'] < start) {
                                start = hour['hourID']
                            }
                            if(hour['hourID'] > end) {
                                end = hour['hourID']
                            }
                        }
                    }
                    this.startTime = start + ":00";
                    this.endTime = (end + 1) + ":00";
                }
                
                // $vm.confirmation = results.msg.confirmation;
                // $vm.reminder = results.msg.reminder;

                this.getMessage(outlet)
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
        },
        async getMessage(outlet){
            let $vm = this
            const url = $vm.$api.BEBUSINESS_OUTLET + "/" + outlet.id + $vm.$api.BOOK_MESSAGE

            $vm.$axios({
                method: 'get', 
                url: `https://bebusiness.tunai.io/outlets/${outlet.id}/book/message`,
                headers: {token: $vm.$session.get('token')}
            })
            .then((response) => {
                var results = response.data[0];
                // $vm.whatsappReminder.whatsapp = results.whatsapp;
                // $vm.whatsappReminder.message = results.message;
                // $vm.whatsappReminder.mobile = results.mobile;
                // $vm.whatsappReminder.outletID = results.outletID;

                this.mobile = results.mobile;
                this.whatsapp = results.whatsapp;
                this.confirmation = results.confirmation;
                this.reminder = results.reminder;
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
        },
        async saveReminder(){
        let $vm = this;
            const url = $vm.$api.BEBUSINESS_OUTLET + "/" + $vm.whatsappReminder.outletID + $vm.$api.BOOK_MESSAGE
      let result = [];
        await this.$axios({
          method: "post",
          url: url,
          headers: { token: this.$session.get("token") },
          data: {
            message: $vm.whatsappReminder.message,
            mobile: $vm.whatsappReminder.mobile,
            whatsapp: $vm.whatsappReminder.whatsapp,
          },
        })
          .then(function (response) {
            result = response;
          })
          .catch((err) => {
            result = err.response;
            var errData = err.response.data;
            if (errData.error == this.$api.INVALID_TOKEN) {
              handleSessionExpired();
            }
          });
        if (result.status === 200) {
          toastrExe(
            $vm,
            "Whatsapp Reminder",
            `Successfully updated Whatsapp Reminder`,
            "success"
          );
          this.whatsappReminder.memberID =
            result.data.members[0].memberID;
        } else {
          toastrExe(
            $vm,
            "New Member",
            `Failed to update Whatsapp Reminder`,
            "danger"
          );
        }
        $vm.bvModal.hide("reminderMessageModal");
        }

    },
    mounted(){
        let $vm = this;
        $vm.outlet = JSON.parse($vm.$store.state.outlets);
        $vm.selectedOutlet = $vm.outlet[0];
        $vm.getBooking($vm.selectedOutlet);
    }
}
</script>